// The colour every pill of a document type paints (FEAT-18 §6.2.12: one stable colour per type): its stored hex, or
// the default a type without one gets. A stored colour that is not hex falls back too: MUI's `darken` throws on a
// colour it cannot parse, and the API stores the string as given.
export const DEFAULT_DOCUMENT_TYPE_COLOR = '#A6C0DC';

const HEX_COLOR = /^#(?:[0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i;

export const documentTypeColor = (color: string | null | undefined): string =>
  color && HEX_COLOR.test(color) ? color : DEFAULT_DOCUMENT_TYPE_COLOR;
